import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { log } from 'log';

import { useShowManagedPopup } from '@core/js/hooks/useShowManagedPopup';

import { RECAPTCHA_ERROR_CODE } from '@interlayer/js/app/components/main/ReCaptchaWithTitle/constants';
import { showDuplicateAccountPopupAction } from '@interlayer/js/app/components/main/Registration/components/popup/DuplicateAccountPopup/actions';
import { showUpgradeMemberPopupAction } from '@interlayer/js/app/components/main/Registration/components/popup/UpgradeMemberPopup/actions';
import { useRegistrationContext } from '@interlayer/js/app/components/main/Registration/hocs/context';
import { useGtmEventReg } from '@interlayer/js/app/components/main/Registration/hooks/useGtmEventReg';
import { getRegistrationErrorMessage } from '@interlayer/js/app/components/main/Registration/utils/parseError';
import { setErrorRegistration } from '@interlayer/js/app/store/reducers/Registration/actions';

export const useHandlerErrorRegistration = () => {
    const gtmEventReg = useGtmEventReg();
    const dispatch = useDispatch();
    const { isClubUpgrade } = useRegistrationContext();
    const showUpgradeMemberPopup = useShowManagedPopup(showUpgradeMemberPopupAction);
    const showDuplicateAccountPopup = useShowManagedPopup(showDuplicateAccountPopupAction);

    return useCallback((error) => {
        log('error', error);

        const errorData = error.data ? error : error.response;
        const messages = getRegistrationErrorMessage(errorData);
        const errorMessages = messages.length ? messages : [messages];

        gtmEventReg(
            'registration_fail',
            {
                playerMessage: messages[0],
                errorCode: errorData?.data?.errorCode,
                errorText: errorData?.data?.errorMessage || errorData?.data?.errorText
            }
        );

        if (!errorData?.data?.errorCode && error.reason) {
            dispatch(setErrorRegistration({
                isShow: true,
                texts: error.reason
            }));

            return;
        }

        if (!errorData?.data?.errorCode) {
            return;
        }

        if (errorData.data.errorCode === 176) {
            showUpgradeMemberPopup();
            return;
        }

        if (errorData.data.errorCode === 16) {
            showDuplicateAccountPopup();
            return;
        }

        if (errorData.data.errorCode === RECAPTCHA_ERROR_CODE) {
            dispatch(setErrorRegistration({
                isShow: true,
                isShowReCaptcha: true,
                isShowLogo: true,
                reCaptchaTitleTKey: 'registration',
                reCaptchaOperation: 'signup'
            }));

            return;
        }

        dispatch(setErrorRegistration({
            isShow: true,
            texts: errorMessages,
            isShowGoToUpgradeButton: isClubUpgrade,
            isShowLoginButton: errorData.data.errorCode === 193
        }));
    }, [dispatch, gtmEventReg, isClubUpgrade, showDuplicateAccountPopup, showUpgradeMemberPopup]);
};
